export default __webpack_public_path__ + "static/media/LA.8c3110e6.svg";